import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useShortIdContext } from "@air/provider-short-id";
import { memo } from "react";
import { useSelector } from "react-redux";
import { ASSET_MODAL_DISCUSSION_FILTERS } from "~/components/AssetModal/shared/context/DiscussionsPanelContext/discussionsPanelContextTypes";
import { getTimestampMarkers } from "~/components/AssetModal/Visualizer/VideoVisualizer/utils";
import { VideoSettingsButton } from "~/components/AssetModalV2/Content/Footer/components/VideoSettingsButton";
import { PublicBoardAssetNavigationArrows } from "~/components/AssetModalV2/Header/PublicBoardAssetComponents/PublicBoardAssetNavigationArrows";
import { useFullscreenContext } from "~/components/AssetModalV2/shared/context/FullscreenContext";
import { FullscreenOverlay } from "~/components/AssetModalV2/Visualizer/shared/components/FullscreenOverlay";
import { VideoVisualizerInner } from "~/components/AssetModalV2/Visualizer/VideoVisualizer/VideoVisualizerInner/VideoVisualizerInner";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { useURLBoardIdSelector } from "~/hooks/useURLBoardIdSelector";
import { centralizedClipSelector } from "~/store/centralizedClip/selectors";
import { usePublicDiscussions } from "~/swr-hooks/discussions/usePublicDiscussions";
import { canEditAssetDiscussions, canViewAssetDiscussions } from "~/utils/permissions/assetPermissions";
export const PublicVideoVisualizer = /*#__PURE__*/ memo(()=>{
    const boardId = useURLBoardIdSelector();
    const clip = useSelector(centralizedClipSelector);
    const { shortId } = useShortIdContext();
    const { permissions } = usePublicPermissions();
    const canViewDiscussions = canViewAssetDiscussions(permissions);
    const canEditDiscussions = canEditAssetDiscussions(permissions);
    const { isFullscreen } = useFullscreenContext();
    const { data: discussions } = usePublicDiscussions({
        boardId,
        assetId: clip.assetId,
        clipId: clip.id,
        shortId,
        isEnabled: canViewDiscussions
    });
    const markers = (discussions === null || discussions === void 0 ? void 0 : discussions.length) && canViewDiscussions ? getTimestampMarkers({
        data: discussions,
        currentVersion: clip.version,
        filter: ASSET_MODAL_DISCUSSION_FILTERS.OPENED
    }) : [];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(VideoVisualizerInner, {
            clip: clip,
            markers: markers,
            canEditDiscussions: canEditDiscussions,
            controls: (_props)=>clip.type === "video" && isFullscreen ? /*#__PURE__*/ _jsx(VideoSettingsButton, {
                    container: _props.container
                }) : /*#__PURE__*/ _jsx(_Fragment, {}),
            fullscreenChildren: /*#__PURE__*/ _jsx(FullscreenOverlay, {
                navigationArrows: boardId ? /*#__PURE__*/ _jsx(PublicBoardAssetNavigationArrows, {}) : null
            })
        })
    });
});
PublicVideoVisualizer.displayName = "PublicVideoVisualizer";
